import React  from 'react';
import NextButton from '../../components/nextButton';
import styled, { keyframes } from 'styled-components';
import { fadeInRight, bounce, bounceIn, zoomIn, pulse } from 'react-animations';

import './style.css';  

const Finik2re = styled.img`
  animation: 3s ${keyframes`${fadeInRight}`} ;
  position: absolute;
  left: auto;
  top: auto;
  right: 10vw;
  bottom: 10vh;
  width: 210px;
  @media screen and (max-width: 991px) {  
    width: 190px;
  }
  @media screen and (max-width: 767px) {
    width: 170px;
  }
  @media screen and (max-width: 479px) {
    bottom: 15vh;
    width: 110px;
  }
`;
{/* <div className="text-block-front"><p>Ты так здорово разгадываешь головоломки! Без тебя я бы не справился! Ключ может быть в городе заколдованных купюр.</p><p>Пойдем поищем?</p></div> */}

const PageRebusEnd = ({ onNextLevel, messNext, answer, setAnswer } ) => {
  return ( 

		<div className="section-info section-itog2">
			<div className="content-front w-container">
				<div className="div-block">
					<div className="text-block-front"><p>Ты так здорово разгадываешь головоломки! Без тебя я бы не справился! Ключ может быть в городе заколдованных купюр.</p><p><span className="span-first">Пойдем поищем?</span></p></div>
					<NextButton classes="button-q w-button" onNextLevel={onNextLevel} messNext="вперёд" />
					</div>
			</div>
			<Finik2re src="images/finik_11.png" loading="lazy" alt="" className="finik2re"/>
		</div>
  );
}

export default PageRebusEnd;
